export default async (locale: string): Promise<string> => {
  const localeMap: Record<string, () => Promise<any>> = {
    de: () => import("../../../translationsFaq/languageHtmlFiles/de.html"),
    en: () => import("../../../translationsFaq/languageHtmlFiles/en.html"),
    es: () => import("../../../translationsFaq/languageHtmlFiles/es.html"),
    fr: () => import("../../../translationsFaq/languageHtmlFiles/fr.html"),
    hr: () => import("../../../translationsFaq/languageHtmlFiles/hr.html"),
    it: () => import("../../../translationsFaq/languageHtmlFiles/it.html"),
    lv_LV: () => import("../../../translationsFaq/languageHtmlFiles/lv-LV.html"),
    pl: () => import("../../../translationsFaq/languageHtmlFiles/pl.html"),
    pt_BR: () => import("../../../translationsFaq/languageHtmlFiles/pt-BR.html"),
    pt_PT: () => import("../../../translationsFaq/languageHtmlFiles/pt.html"),
    tr: () => import("../../../translationsFaq/languageHtmlFiles/tr.html"),
    uk: () => import("../../../translationsFaq/languageHtmlFiles/uk.html"),
  };

  const importFn = localeMap[locale] || localeMap.en;
  const module = await importFn();

  // Parcel bundles HTML differently in dev vs production
  const html = typeof module === "string" ? module : module.default || module[1] || module;

  const bodyContent = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
  return bodyContent ? bodyContent[1] : html;
};
